module.exports = __webpack_public_path__ + "static/img/logo.18bfd228.png";